import { render, staticRenderFns } from "./Mandatory.vue?vue&type=template&id=b8946376&"
import script from "./Mandatory.vue?vue&type=script&lang=js&"
export * from "./Mandatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports